import { Component } from '@angular/core';

@Component({
  selector: 'webapp-compat-navigation-secondary-hire-freelancers',
  template: `
    <app-navigation-secondary-hire-freelancers></app-navigation-secondary-hire-freelancers>
    <router-outlet></router-outlet>
  `,
})
export class CompatNavigationSecondaryHireFreelancersComponent {}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/pl/webapp/src/compat/compat-navigation-secondary-hire-freelancers.component.ts